<!--
 * @Description: 列表中职业认证状态
 * @Date: 2021-03-31 18:02:17
-->
<template>
  <el-button
    type="text"
    :disabled="occupationAuthStatus == 0"
    :style="{ color: current.color }"
    @click="showDetail"
  >
    {{ current.text }}
  </el-button>
</template>

<script>
import Detail from './Detail.vue';
const occupationMap = {
  2: {
    text: '已认证',
    color: '#409EFF'
  },
  0: {
    text: '未认证'
  }
};
export default {
  name: 'OccupationAuthStatus',
  props: {
    occupationAuthStatus: {
      type: Number,
      default: 0,
      required: true
    },
    userId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {
    current() {
      return occupationMap[this.occupationAuthStatus];
    }
  },
  methods: {
    showDetail() {
      if (this.occupationAuthStatus !== 2) {
        return false;
      }
      this.$xrkDialog({
        title: '职业认证',
        width: '40%',
        showConfirm: false,
        cancelText: '确认',
        cancelType: 'primary',
        $slots: {
          default: this.$createElement(Detail, {
            props: { userId: this.userId }
          })
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
